import { DeleteOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Space, Spin, Tooltip, Divider, message, } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import backBtn from "../../assets/images/back-arrow.svg";
import UserIcon from "../../assets/images/icons/userLogo.svg";
import plusIcon from "../../assets/images/plusIcon.svg";
import ImageLabel from "../../common/image-label";
import Line from "../../common/line";
import { useConnectsUForm } from "../../custom-hooks/useConnectsUForm";
import { useTab } from "../../custom-hooks/useTab";
import { useStore } from "../../store";
import { setUpdatedValues } from "../../store/actions";
import { getFormFieldValue } from "../../utils";
import "./index.scss";

import { formatData } from "../../utils/formatData";
import { inputFieldCharLimit } from "../../config";


export default function EditSponsors({
  dataLoader,
}) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const rowData = state?.data ? state?.data : "";
  const page = state?.page ? state?.page : "";
  const [form] = Form.useForm();
  const [tabData, setTabData] = useState([{ title: "" }]);
  const whichTab = "logo";
  const currentTab = "LOGO";
  const [loader, setLoader] = useState(dataLoader ? dataLoader : false);
  const [loading, setLoading] = useState(true);
  const { getSponsorList, callMicroServices } = useTab();
  const { updateImage } = useConnectsUForm();
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const { updatedValues, dispatch, sponsors } = useStore();
  const [partnerLogos, setpartnerLogos] = useState([]);
  const partnername = sessionStorage.getItem("OrgName");

  // ✅ New state management for unsaved items
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // ✅ Empty Row Template
  const emptyRow = {
    id: undefined,
    description: "",
    urlLink: "",
    mediaLink: { url: "" },
    blob: undefined,
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, "logo", i, key);
  };

  // ✅ Refresh Unsaved State
  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue("logo") || [];
    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.description?.trim() ||
        item?.urlLink?.trim() ||
        item?.mediaLink?.url?.trim() ||
        item?.blob;
      return !item?.id && hasData;
    });

    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  };

  // ✅ Handle Add More - NEW ITEMS AT TOP
  const handleAddMore = () => {
    const currentList = form.getFieldValue("logo") || [];
    const newList = [emptyRow, ...currentList]; // Add new row on top
    form.setFieldsValue({ "logo": newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Handle Clear - CLEAR ONLY THE FIRST (NEWEST) UNSAVED ITEM
  const handleClear = () => {
    const currentList = form.getFieldValue("logo") || [];

    // Find the first unsaved item (index 0, since new items are added at top)
    const firstUnsavedIndex = currentList.findIndex(item => !item?.id);

    if (firstUnsavedIndex === -1) {
      message.warning("No unsaved item to clear.");
      return;
    }

    // Clear ONLY the first unsaved item
    const updatedList = currentList.map((item, idx) =>
      idx === firstUnsavedIndex
        ? {
          ...item,
          description: "",
          urlLink: "",
          mediaLink: { url: "" },
          blob: undefined,
        }
        : item
    );

    form.setFieldsValue({ "logo": updatedList });

    // ✅ Recalculate unsaved state
    const stillUnsaved = updatedList.some(item =>
      !item?.id &&
      (
        item?.description?.trim() ||
        item?.urlLink?.trim() ||
        item?.mediaLink?.url?.trim() ||
        item?.blob
      )
    );

    // setCanAddNew(!stillUnsaved);
    // setHasUnsavedItem(stillUnsaved);

    // message.success("New unsaved item cleared.");
  };

  const handleUpdateItem = async (data) => {
    setIsBtnLoading(true);
    let existingData = [],
      newData = [];
    if (data["logo"]) {
      data["logo"].map((item) => {
        if (item.id) {
          existingData.push(item);
        } else {
          newData.push(item);
        }
      });
      const formattedData = formatData("logo", data["logo"], updatedValues);
      if (Object.keys(formattedData).length > 0) {
        dispatch(setUpdatedValues({}));
        callMicroServices("logo", formattedData, form);

        // ✅ Reset unsaved state after successful save
        setCanAddNew(true);
        setHasUnsavedItem(false);

        setTimeout(() => {
          setIsBtnLoading(false);
          if (page === "home") {
            navigate('/partner-org')
          } else {
            navigate('/sponsors')
          }
        }, 2000);
      } else {
        setIsBtnLoading(false);
        toast.error("Nothing to update");
      }
    }
  };

  const fieldsChange = (fields) => {
    if (fields && fields.length === 1) {
      const getNames = fields[0].name;
      const nameModified = getNames[0] === "logo" ? "logo" : getNames[0];

      var prev = updatedValues;

      const prevItems = prev[nameModified];
      if (prevItems) {
        const names = [...prevItems, getNames[1]];
        const removeDuplicates = names.filter(function (
          item,
          index,
          inputArray
        ) {
          return inputArray.indexOf(item) == index;
        });
        prev[nameModified] = removeDuplicates;
      } else {
        prev[nameModified] = [getNames[1]];
      }

      const getAllField = form.getFieldsError();
      dispatch(setUpdatedValues(prev));
    }
  };

  // ✅ Subscribe to form changes for unsaved state
  useEffect(() => {
    refreshUnsavedState(); // Initial check
    setCanAddNew(false);
    setHasUnsavedItem(true);
  }, []);

  useEffect(() => {
    const unsubscribe = form.subscribe?.(() => refreshUnsavedState());
    return () => unsubscribe?.();
  }, [form]);

  useEffect(() => {
    form.resetFields();
  }, [tabData]);

  if (!loading) {
    return (
      <div className="data-loader">
        <Spin className="loading-svg" tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div className="tabContainer">
        <div className="main-container" style={{ paddingTop: "5px" }}>
          <div className="header-container">
            <div className="backbtn-container">
              <img src={backBtn} onClick={() => page === "home" ? navigate('/partner-org') : navigate('/sponsors')} alt="" />
              <p>{page === "addsponsors" ? "Add sponsor" : page === "editsponsors" ? "Edit sponsor" : "Add sponsor"}</p>
            </div>
          </div>
          <div className="edit-video-container">
            <div className="formInfoStyle changePassword">
              <Form
                name="control-hooks"
                className="organizationForm"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 18,
                }}
                form={form}
                autoComplete="off"
                onFinish={handleUpdateItem}
                onFieldsChange={fieldsChange}
              >

                <Form.List
                  name="logo"
                  initialValue={rowData ? [rowData] : [emptyRow]}
                >
                  {(fields, { add, remove }) => (
                    <>
                      {page === "addsponsors" &&
                        <div className="formInfoRow">
                          <div className="formInfoCol">
                            <div className="more-btn-container">
                              <Button
                                className="form-clear-btn"
                                type="button"
                                onClick={handleClear}
                              >
                                Clear
                              </Button>
                              <Button
                                className="form-add-btn"
                                onClick={handleAddMore}
                              >
                                <img src={plusIcon} alt="" />
                                Add More
                              </Button>
                            </div>
                          </div>
                        </div>
                      }
                      {fields.map(({ key, name, ...restField }, i) => (
                        <div key={key}>
                          <div className="formInfoRow">
                            <div className="formInfoCol">
                              <div className="d-flex">
                                <Form.Item
                                  {...restField}
                                  className="edit-videos-title"
                                  label="Description"
                                  name={[name, "description"]}
                                  labelCol={{ span: 6 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Description is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Description"
                                    maxLength={100}
                                    showCount
                                  />
                                </Form.Item>
                                <Form.Item>
                                  {fields.length > 1 ? (
                                    <div className="remove-btn">

                                      <DeleteOutlined
                                        title="Delete"
                                        onClick={() => {
                                          remove(name);
                                          setHasUnsavedItem(false);
                                          refreshUnsavedState();
                                        }}
                                      />
                                    </div>
                                  ) : null}
                                </Form.Item>

                              </div>
                            </div>
                          </div>
                          <div className="formInfoRow">
                            <div className="formInfoCol">
                              <Form.Item
                                {...restField}
                                className="edit-videos-title"
                                label="Sponsor Link"
                                name={[name, "urlLink"]}
                                labelCol={{ span: 6 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Sponsor link is required",
                                  },
                                  {
                                    type: "url",
                                    message: "Please enter a valid URL",
                                  },
                                ]}
                              >
                                <Input placeholder="Sponsor link" maxLength={inputFieldCharLimit} />
                              </Form.Item>

                            </div>
                          </div>
                          <div className="formInfoRow">
                            <div className="formInfoCol">
                              <Form.Item
                                {...restField}
                                label={<ImageLabel label={"Logo"} />}
                                colon={false}
                                name={[name, "mediaLink"]}
                                className="experienceImg"
                                labelCol={{ span: 6 }}
                                rules={[
                                  {
                                    validator: (_, value) => {
                                      return findValue(i, "blob")
                                        ? Promise.resolve()
                                        : findValue(i, "url")
                                          ? Promise.resolve()
                                          : Promise.reject(
                                            new Error("Image is required")
                                          );
                                    },
                                  },
                                ]}
                              >
                                {findValue(i, "blob") ? (
                                  <img
                                    className="form-image"
                                    src={URL.createObjectURL(
                                      findValue(i, "blob")
                                    )}
                                    alt=""
                                  />
                                ) : findValue(i, "url") ? (
                                  <img className="form-image" src={findValue(i, "url")} alt="" />
                                ) : (
                                  <img className="form-image" src={UserIcon} />
                                )}
                                <>
                                    <label
                                      name="file"
                                      className="fileUploadBtn"
                                    >
                                      {" "}
                                      Upload Image
                                      <input
                                        accept="image/png, image/gif, image/jpeg"
                                        type="file"
                                        onChange={(e) => {
                                          updateImage(e, i, form, whichTab);
                                          // 🔁 Force re-render after image upload
                                          setTimeout(() => setRefreshKey((prev) => prev + 1), 200);
                                        }}
                                      />
                                    </label>
                                  <Tooltip title="Upload image with size lesser than 2.5MB. Recommended image dimensions: 1280x720 pixels. Use a square image for best results">
                                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: "pointer", fontSize: '18px', color: '#569dfa' }} />
                                  </Tooltip>
                                </>

                              </Form.Item>
                            </div>
                          </div>
                          <Divider className='members-orgs-stats-divider' />
                        </div>

                      ))}

                    </>
                  )}
                </Form.List>
              </Form>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <div className="form-btn-container">
                    <Button
                      className="form-cancel-btn"
                      onClick={() => page === "home" ? navigate('/partner-org') : navigate('/sponsors')}
                    >
                      Cancel
                    </Button>
                    <Button className="form-save-btn" htmlType="submit" onClick={() => form.submit()} loading={isBtnLoading}>
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}